import { usePrevious } from "../Hooks/usePrevious";
import { SlidingCharacter } from './SlidingCharacter'
import styled from 'styled-components'
import { HStack, VStack } from "../Components/Stack"
import { ComponentProps, ReactNode } from 'react'
import { Text } from './Text'
import { Panel } from './Panel'
import { padWithZero } from '../Functions'
import { useMediaQuery } from "@mui/material";

export type ComponentWithChildrenProps = {
  children: ReactNode
}

export const Center = ({
  children,
  ...rest
}: ComponentWithChildrenProps & ComponentProps<typeof VStack>) => (
  <VStack
    fullWidth
    fullHeight
    alignItems="center"
    justifyContent="center"
    {...rest}
  >
    {children}
  </VStack>
)


interface Props {
  value: number
}

const Container = styled(Panel)`
  width: 90px;
  height: 120px;
  padding: 8px;

  position: relative;
  overflow: hidden;
  display: flex;

  font-weight: 600;
  font-size: 40px;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  border: 1px solid rgba(0, 0, 0, 0.6);
`

const CharacterContainer = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
`

export const CountdownPart = ({ value }: Props) => {
  const isMobile = useMediaQuery('(max-width: 700px)')
  const previousValue = usePrevious(value)
  const [currentString, previousString] = [value, previousValue || value].map(
    (number) => padWithZero(number),
  )


  return (
    <Container style={{
      width: isMobile ? 'calc(30px + 10vw)' : '90px', padding: isMobile ? '2px' : '8px'
    }}>
      <Center>
        <HStack >
          {currentString.split('').map((character, index) => {
            const previousCharacter = previousString[index]
            const animationId =
              previousCharacter !== character
                ? `${previousCharacter}${character}`
                : undefined

            return (
              <CharacterContainer key={index}>
                <Text style={{ visibility: 'hidden' }}>{character}</Text>
                <SlidingCharacter as="div" animationId={animationId} >
                  <Text>{previousCharacter}</Text>
                  <Text>{character}</Text>
                </SlidingCharacter>
              </CharacterContainer>
            )
          })}
        </HStack>
      </Center>
    </Container>
  )
}
